/**
 * Created by DELL on 2017/12/27.
 */
import $ from 'jquery';
// import NProgress from 'nprogress';
import {Notification} from 'element-react';
import tools from '@/utils/tool';
/*
 * params: object
 *
 * object.url:   api地址 String， 不能为空
 * object.type:  请求方式 String， 默认get
 * object.async: 是否异步 Boolean，默认true
 * object.data:  请求数据 object， 默认{}
 * */
export default function httpRequest(obj) {
  let async = true; // 异步
  if (typeof(obj.async) === 'undefined') {
    async = true;
  } else {
    async = Boolean(obj.async);
  }
  const data = obj.data || {};
  return $.ajax({
    url: obj.url,
    timeout : 300000, //超时时间设置，单位毫秒
    type: obj.type || 'GET',
    headers: {
      version: 'v101'
    },
    async: async,
    dataType: 'json',
    data: {...data},
  }).done(resp=> {
    if (resp.ret === -1000) { // 登录过期
      Notification({
        title: '登录过期',
        message: '登录已过期，请重新登录',
        type: 'error',
      });
      setTimeout(function () {
        tools.removeUserData();
        window.location.href = window.location.pathname;
      }, 1500);
      return false;
    }
  }).fail(err => {
  });
};



// WEBPACK FOOTER //
// ./src/utils/httpRequest.js